import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Laptop = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M18 3.25049C19.5188 3.25049 20.75 4.48171 20.75 6.00049V15.2505H22C22.4142 15.2505 22.75 15.5863 22.75 16.0005V18.0005C22.75 19.5193 21.5188 20.7505 20 20.7505H4C2.48122 20.7505 1.25 19.5193 1.25 18.0005V16.0005C1.25 15.5863 1.58579 15.2505 2 15.2505H3.25V6.00049C3.25 4.48183 4.48139 3.25069 6 3.25049H18ZM2.75 18.0005C2.75 18.6908 3.30964 19.2505 4 19.2505H20C20.6904 19.2505 21.25 18.6908 21.25 18.0005V16.7505H2.75V18.0005ZM6 4.75049C5.30981 4.75069 4.75 5.31025 4.75 6.00049V15.2505H19.25V6.00049C19.25 5.31013 18.6904 4.75049 18 4.75049H6Z'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.25 6C3.25 4.48122 4.48122 3.25 6 3.25H18C19.5188 3.25 20.75 4.48122 20.75 6V15.25H22C22.4142 15.25 22.75 15.5858 22.75 16V18C22.75 19.5188 21.5188 20.75 20 20.75H4C2.48122 20.75 1.25 19.5188 1.25 18V16C1.25 15.5858 1.58579 15.25 2 15.25H3.25V6ZM2.75 16.75V18C2.75 18.6904 3.30964 19.25 4 19.25H20C20.6904 19.25 21.25 18.6904 21.25 18V16.75H2.75Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
